import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import ArticlesContent from '../../components/Pages/TippingArticles';

const { displayName } = config;

export default function TippingArticles(): React.ReactElement {
  document.title = `${displayName}: Tipping Articles`;

  return (
    <Layout>
      <ArticlesContent />
    </Layout>
  );
}
